import { createAction, props } from '@ngrx/store';
import { Notification } from '../notification.model';

export const loadNotifications = createAction( '[Notifications] Load User Notifications' );

export const loadNotificationsSuccess = createAction( '[Notifications] Load User Notifications Success',
  props<{ notifications: Notification[] }>()
);
export const loadNotificationsFailure = createAction( '[Notifications] Load User Notifications Failure' );

export const connectToNotifications = createAction( '[Notifications] Connect WebSocket' );

export const disconnectToNotifications = createAction( '[Notifications] Disconnect WebSocket' );

export const notificationReceived = createAction(
  '[Notifications] Notification Received',
  props<{ notification: Notification }>()
);

export const setAsRead = createAction(
  '[Notifications] Set Notifications as Read',
  props<{ notification: Notification }>()
);

export const setAsReadSuccess = createAction(
  '[Notifications] Set Notifications as Read Success',
  props<{ notification: Notification }>()
);

export const setAsReadFailure = createAction(
  '[Notifications] Set Notifications as Read Failure',
);
